import Sniffer from 'snifferjs';

// store
import { app } from '../utils/store';

import Animations from '../modules/animations/animations';
import Carousel from '../modules/carousel/carousel';
import Counters from '../modules/counters/counters';
import Filters from '../modules/filters/filters';
import Forms from '../modules/forms/forms';
import Footer from '../modules/footer/footer';
import Gallery from '../modules/gallery/gallery';
import Header from '../modules/header/header';
import Maps from '../modules/maps/maps';
import Modal from '../modules/modal/modal';
import Search from '../modules/search/search';
import Scroll from '../modules/scroll/scroll'; // Alert : Uses jQuery
import Switch from '../modules/switch/switch';
// import Video from '../modules/video/video';
export default class Components {
    constructor() {
        this.switch = document.getElementById('switch');
        this.carousel = document.querySelector('.carousel');
        this.filters = document.getElementById('filters');
        this.footer = document.querySelector('footer');
        this.gallery = document.getElementById('gallery');
        this.counters = document.querySelector('.numbers-template-general .number');
        this.header = document.querySelector('header');
        this.search = document.getElementById('search-toggler');
        this.map = document.getElementById('map');
        this.menu = document.getElementById('main-menu');
        this.modal = document.querySelector('.btn-modal');
        this.video = document.querySelector('video');
        this.animations = document.querySelector('body');

        this.page = {
            test: document.querySelector('.page-test'),
        }

        this.post = {
            test: document.querySelector('.page-test-article'),
        }
    }

    init(){
        app.scroll = new Scroll();
        app.scroll.init();

        if(this.header){
            this.header = new Header();
            this.header.init();
        }

        if(this.footer){
            this.footer = new Footer();
            this.footer.init();
        }

        if(this.carousel){
            this.carousel = new Carousel();
            this.carousel.init();
        }

        if(this.counters){
            this.counters = new Counters();
            this.counters.init();
        }

        if(this.filters){
            this.filters = new Filters();
            this.filters.init();
        }
        
        if(this.form){
            this.form = new Forms();
            this.form.init();
        }
        if(this.map){
            this.map = new Maps();
            this.map.init();
        }
        if(this.modal){
            this.modal = new Modal();
            this.modal.init();
        }
        if(this.animations){
            this.animations = new Animations();
            this.animations.init();
        }
        if(this.switch){
            this.switch = new Switch();
            this.switch.init();
        }
        if(this.search){
            this.search = new Search();
            this.search.init();
        }
        if(this.gallery){
            this.gallery = new Gallery();
            this.gallery.init();
        }
    }

    destroy = () => {
        console.log('Destroy Components')
        // Destroy Components using JS
    }
}
